import { formatNumericValue } from "../../../utils/chartData";
import { BODY_TEXT_COLOR } from "./chartConstants";
export var buildBarValueLabel = function (position) { return ({
    show: true,
    position: position,
    distance: 8,
    color: BODY_TEXT_COLOR,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 10,
    formatter: function (_a) {
        var value = _a.value;
        return value > 0 ? formatNumericValue(value) : "";
    },
}); };
export var getPaddedAxisMax = function (values) {
    var max = values.reduce(function (currentMax, value) { return Math.max(currentMax, value); }, 0);
    if (max <= 0)
        return undefined;
    return Math.ceil(max * 1.12);
};
